import { sfMetaobject } from "@unlikelystudio/commerce-connector"

import { sfFetchWrapper } from "~/lib/shopify/utils/sf-fetch-wrapper"

export const getSfMetaobject = sfFetchWrapper(sfMetaobject)("product", "collection")
